import { FC, useEffect, useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { isEmpty } from 'radash';
import { analytics } from '@shared/utils/segment.utils';
import { ActiveLine, ContentContainer, ContentWrapper, ContentWrapperLight } from './Content.style';
interface Props {
  setIsOpen: (val: boolean) => void;
}
const Content: FC<Props> = ({
  setIsOpen
}: Props) => {
  const router = useRouter();
  const [activePath, setActivePath] = useState('');
  useEffect(() => {
    handleActiveMenu();
  }, [router]);
  const handleActiveMenu = () => {
    const path = router.pathname.split('/')[1];
    setActivePath(path);
  };
  const onClickMenu = (title: string, linkout?: string) => {
    analytics.track('Hamburger Menu Click Menu', {
      event: 'Hamburger Menu Click Menu',
      menu: title
    });
    if (!isEmpty(linkout)) {
      analytics.track('Offsite Linked', {
        event: 'Offsite Linked',
        destination_url: linkout
      });
    }
    setIsOpen(false);
  };
  return <ContentContainer onMouseLeave={() => setIsOpen(false)}>
            <Link href="/food-service" onClick={() => onClickMenu('ฟู้ดเซอร์วิส')}>
                <ActiveLine $isActive={activePath === 'food-service'} />
                <ContentWrapper>ฟู้ดเซอร์วิส</ContentWrapper>
            </Link>
            <Link href="/cp-connect" onClick={() => onClickMenu('ซีพี คอนเนค')}>
                <ActiveLine $isActive={activePath === 'cp-connect'} />
                <ContentWrapper>ซีพี คอนเนค</ContentWrapper>
            </Link>
            <Link href="/contact" onClick={() => onClickMenu('ติดต่อเรา')}>
                <ActiveLine $isActive={activePath === 'contact'} />
                <ContentWrapper>ติดต่อเรา</ContentWrapper>
            </Link>
            {/* hide ไว้ก่อน */}
            {/* <Link
                href="https://www.cpbrandsite.com/กินอย่างยั่งยืน"
                target="_blank"
                onClick={() => onClickMenu('กินอย่างยั่งยืน', 'https://www.cpbrandsite.com/กินอย่างยั่งยืน')}
             >
                <ActiveLine $isActive={false} />
                <ContentWrapper>กินอย่างยั่งยืน</ContentWrapper>
             </Link> */}
            <Link href={process.env.CDP_DOMAIN} onClick={() => onClickMenu('สมาชิกซีพีแบรนด์', process.env.CDP_DOMAIN)}>
                <ActiveLine $isActive={false} />
                <ContentWrapper>สมาชิกซีพีแบรนด์</ContentWrapper>
            </Link>
            <Link href={`${process.env.CDP_DOMAIN}/survey`} onClick={() => onClickMenu('แบบสอบถาม', `${process.env.CDP_DOMAIN}/survey`)}>
                <ActiveLine $isActive={false} />
                <ContentWrapperLight>
                    <span>•</span> แบบสอบถาม
                </ContentWrapperLight>
            </Link>
            <Link href={`${process.env.CDP_DOMAIN}/product`} onClick={() => onClickMenu('รีวิวสินค้า', `${process.env.CDP_DOMAIN}/product`)}>
                <ActiveLine $isActive={false} />
                <ContentWrapperLight>
                    <span>•</span> รีวิวสินค้า
                </ContentWrapperLight>
            </Link>
        </ContentContainer>;
};
export default Content;